import {alpha} from "@mui/material/styles";
import {darken} from "@mui/material";

export const trexoTheme = {
    type: "light",
    palette: {
        primary: {
            main: '#7352C7',
            light: '#A67FFB',
            dark: '#5E3BB7',
            contrastText: '#FFFFFF',
            hover: '#FFFFFF'
        },
        secondary: {
            main: '#E44A77',
            light: '#FF7EA6',
            dark: '#DF295E',
            contrastText: '#FFFFFF'
        },
        error: {
            main: '#E73145',
            light: '#FF6A70',
            dark: '#AD001E',
            contrastText: '#FFFFFF'
        },
        warning: {
            main: '#F39711',
            light: '#FFC84C',
            dark: '#BB6900',
            contrastText: '#FFF'
        },
        info: {
            main: '#2EB5C9',
            light: '#6FE7FC',
            dark: '#008598',
            contrastText: '#FFFFFF'
        },
        success: {
            main: '#3BD2A2',
            light: '#78FFD3',
            dark: '#00A073',
            contrastText: '#FFFFFF'
        },
        text: {
            primary: '#C5CDE6',
            secondary: '#8595A6',
            disabled: '#A2B2C3',
        },
        nav: {
            
            action: {
                active: '#010160',
                disabled: 'none',
                hover: '#FFFFFF',
               
            },
            background: {
                active: '#FFFFFF',
                hover: alpha('#FFFFFF', 0.6),
                disabled:"#010160"
            },
            tick: {
                active: darken('#FFFFFF', .25),
                hover: alpha('#F5F7FA', .25),
                disabled: "#010160"
            }
        },
        divider : '#DEE2E6',
        background: {
            paper: '#010160',
            default: '#010160',
        },
        action: {
            active: '#475259',
            hover: '#F5F7FA',
            disabled: "none",
        },
    }
};